import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { useLocalizedPartnerDirectoryHref } from "@/libraries/web-framework/src/localization/use-localized-partnerdirectory.ts";
import {
    featureFlags,
    checkFeatureFlagGate
} from "@/utils/feature-flags/index.ts";

import { Link } from "../../../../libraries/design/components/link/src/link.tsx";

import type { LinkProps } from "../../../../libraries/design/components/link/src/link.tsx";

export const UniformLink = (props: LinkProps) => {
    let localizedHref = useLocalizedHref(props.href);

    const localizedPartnerDirectoryUrl = useLocalizedPartnerDirectoryHref(
        props.href
    );
    const checkGate = checkFeatureFlagGate(
        featureFlags.gwpUniformLinkLocalizePartnerDirectory
    );
    if (checkGate && props.href !== localizedPartnerDirectoryUrl) {
        localizedHref = localizedPartnerDirectoryUrl;
    }

    return <Link {...props} href={localizedHref} />;
};

export default UniformLink;
